"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAtEnd;

var _react = require("react");

var _StateContext = _interopRequireDefault(require("../ScrollToBottom/StateContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useAtEnd() {
  var context = (0, _react.useContext)(_StateContext.default);
  return [context.atEnd];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VBdEVuZC5qcyJdLCJuYW1lcyI6WyJ1c2VBdEVuZCIsImNvbnRleHQiLCJTdGF0ZUNvbnRleHQiLCJhdEVuZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBOzs7O0FBRWUsU0FBU0EsUUFBVCxHQUFvQjtBQUNqQyxNQUFNQyxPQUFPLEdBQUcsdUJBQVdDLHFCQUFYLENBQWhCO0FBRUEsU0FBTyxDQUFDRCxPQUFPLENBQUNFLEtBQVQsQ0FBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IFN0YXRlQ29udGV4dCBmcm9tICcuLi9TY3JvbGxUb0JvdHRvbS9TdGF0ZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VBdEVuZCgpIHtcbiAgY29uc3QgY29udGV4dCA9IHVzZUNvbnRleHQoU3RhdGVDb250ZXh0KTtcblxuICByZXR1cm4gW2NvbnRleHQuYXRFbmRdO1xufVxuIl19